import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import {
  CardOverline, CardDate, CardBodyText,
  CardTextContainer, CardContainer, FullWidthImageContainer,
} from '../Card';
import Headline5 from '../Typography/Heading/Headline5';
import Labels, { FeaturedLabel, MemberAccessLabel } from '../Card/Labels';
import cardPropertyTypes from './propertyTypes';

const StyledHeadline5 = styled(Headline5)<
{
  hasIcon: boolean;
}
>`
  && {
    margin: 0 0 8px;
    ${(properties : { hasIcon: boolean }) => properties.hasIcon && `
      display: flex;
      justify-content: space-between;
    `
}
  }
`;

const mediumCardPropertyTypes = {
  ...cardPropertyTypes,
  children: PropTypes.node,
  icon: PropTypes.node,
  featured: PropTypes.bool,
  memberAccess: PropTypes.bool,
  memberAccessLabelText: PropTypes.string,
  logoLetterbox: PropTypes.bool,
  isPressRelease: PropTypes.bool,
  isPartnerContent: PropTypes.bool,
};

type MediumCardProperties = InferProps<typeof mediumCardPropertyTypes> & {
  featured?: boolean;
  memberAccess?: boolean;
  withPageMargins?: boolean;
  logoLetterbox?: boolean;
  isPressRelease?: boolean;
  isPartnerContent?: boolean;
};

const MediumCard = ({
  title,
  category,
  insertedAt,
  image,
  description,
  labels = [],
  children,
  icon,
  featured = false,
  memberAccess = false,
  memberAccessLabelText,
  withPageMargins = false,
  logoLetterbox = false,
  isPressRelease = false,
  isPartnerContent = false,
} : MediumCardProperties) => (
  <CardContainer className="card-container">
    {image && (
    <FullWidthImageContainer
      featured={featured}
      withPageMargins={withPageMargins}
      logoLetterbox={logoLetterbox}
    >
      {image}
    </FullWidthImageContainer>
    )}
    <CardTextContainer>
      { category && (
        <CardOverline>
          <Labels
            category={category}
            labels={labels}
            isPressRelease={isPressRelease}
            isPartnerContent={isPartnerContent}
          />
          {featured && (
            <FeaturedLabel>Featured</FeaturedLabel>
          )}
          {memberAccess && (
            <MemberAccessLabel>{memberAccessLabelText}</MemberAccessLabel>
          )}
        </CardOverline>
      )}
      <StyledHeadline5
        tag="h2"
        hasIcon={Boolean(icon)}
      >
        {title}
        {icon}
      </StyledHeadline5>
      {
        description && (
          <CardBodyText>
            {description}
          </CardBodyText>
        )
      }
      {insertedAt && <CardDate>{insertedAt}</CardDate>}
      { children }
    </CardTextContainer>
  </CardContainer>
);

MediumCard.propTypes = mediumCardPropertyTypes;

export default MediumCard;
